import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import styles from './Content.module.css';

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const pages = [];
  const start = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let page = start; page <= end; page += 1) pages.push(page);

  return (
    <nav className={styles.pagination} aria-label="Article pages">
      <button type="button" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}><MdKeyboardArrowLeft /></button>
      {pages.map((page) => <button type="button" key={page} className={page === currentPage ? styles.currentPage : ''} onClick={() => setCurrentPage(page)}>{page}</button>)}
      <button type="button" onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}><MdKeyboardArrowRight /></button>
    </nav>
  );
};

export default Pagination;
